import script from "./FIUTemplaces.vue?vue&type=script&setup=true&lang=js"
export * from "./FIUTemplaces.vue?vue&type=script&setup=true&lang=js"

import "./FIUTemplaces.vue?vue&type=style&index=0&id=7167e8de&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7167e8de"]])

export default __exports__